<script setup>
import { computed } from 'vue'
import {
  faFloppyDisk, faBook, faWandMagicSparkles, faGlobe, faGear, faEye,
  faQuestion, faMinus, faPlus, faXmark, faChevronDown, faChevronUp, faTrashCan,
  faTrash, faPenToSquare, faBars, faTableColumns, faComment, faArrowRight,
  faArrowLeft, faArrowsLeftRight,
  faScissors, faCopy, faPaste,
} from '@fortawesome/free-solid-svg-icons'
import { faFolderOpen } from '@fortawesome/free-regular-svg-icons'

const iconMap = {
  'floppy-disk': faFloppyDisk,
  'book': faBook,
  'wand-magic-sparkles': faWandMagicSparkles,
  'globe': faGlobe,
  'gear': faGear,
  'eye': faEye,
  'question': faQuestion,
  'minus': faMinus,
  'plus': faPlus,
  'xmark': faXmark,
  'chevron-down': faChevronDown,
  'chevron-up': faChevronUp,
  'folder-open': faFolderOpen,
  'trash-can': faTrashCan,
  'trash': faTrash,
  'pen-to-square': faPenToSquare,
  'bars': faBars,
  'table-columns': faTableColumns,
  'comment': faComment,
  'arrow-right': faArrowRight,
  'arrow-left': faArrowLeft,
  'arrows-left-right': faArrowsLeftRight,
  'scissors': faScissors,
  'copy': faCopy,
  'paste': faPaste,
}

const props = defineProps({
  name: { type: String, required: true },
})

const def = computed(() => iconMap[props.name])
const viewBox = computed(() => def.value ? `0 0 ${def.value.icon[0]} ${def.value.icon[1]}` : '0 0 512 512')
const paths = computed(() => {
  if (!def.value) return []
  const p = def.value.icon[4]
  return Array.isArray(p) ? p : [p]
})
</script>

<template>
  <svg
    :viewBox="viewBox"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    class="app-icon"
  >
    <path v-for="(p, i) in paths" :key="i" :d="p" />
  </svg>
</template>

<style scoped>
.app-icon {
  display: inline-block;
  height: 1em;
  width: auto;
  vertical-align: -0.125em;
}
</style>
